import { render } from "./DocumentCounter.vue?vue&type=template&id=384ea1cd&scoped=true"
import script from "./DocumentCounter.vue?vue&type=script&lang=js"
export * from "./DocumentCounter.vue?vue&type=script&lang=js"

import "./DocumentCounter.vue?vue&type=style&index=0&id=384ea1cd&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384ea1cd"]])

export default __exports__